import {
    UPDATE_CURRENT_URL,
    DELETE_CURREMT_URL
} from '../constants/currentUrlConstants';

//#region UPDATE CURRENT URL
export function updateCurrentLocation(data,  returnToHome=undefined) {
    return {
        type: UPDATE_CURRENT_URL,
        data,
        returnToHome
    }
};

export function UpdateCurrentLocation( returnToHome=undefined) {
    return dispatch => {

        const location = window.location;
        if(!location) return undefined
        
        dispatch(updateCurrentLocation(location,returnToHome));        
        return true;
    }
};
//#endregion

//#region DELETE CURRENT URL
export function deleteCurretLocation(data) {
    return {
        type: DELETE_CURREMT_URL,
        data
    }
};

export function DeleteCurretLocation() {
    return dispatch => {

        const location = window.location;
        if(!location) return undefined

        dispatch(deleteCurretLocation(location));        
        return true;
    }
};
//#endregion